import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const NotificationsRaw = React.lazy(() => import(/* webpackChunkName: "NotificationsPage" */ './Notifications'));
export const Notifications = () => (React.createElement(Page, { title: "Notifications", description: "Manage Inbox" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(NotificationsRaw, null)))));
